import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_API = process.env.REACT_APP_BASE_API;
const KRANKQUE_SECRET_KEY = process.env.REACT_APP_KRANKQUE_SECRET_KEY;
const KRANKQUE_APPLICATION_ID = process.env.REACT_APP_KRANKQUE_APPLICATION_ID;

interface Notification {
  id: string;
  notificationValue: string;
  createdAt: string;
  isViewed: boolean;
}

interface GetNotificationsResponse {
  success: boolean;
  message: string;
  data: {
    total: number;
    notifications: Notification[];
  };
}

interface GetNotificationsParams {
  accessToken: string;
  limit: number;
  skip: number;
}

interface MarkAsViewedRequest {
  accessToken: string;
  ids: string[];
}

interface MarkAsViewedResponse {
  success: boolean;
  message: string;
}

export const notificationSlice = createApi({
  reducerPath: 'notification',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      if (KRANKQUE_SECRET_KEY) headers.set('krankque-secret-key', KRANKQUE_SECRET_KEY);
      if (KRANKQUE_APPLICATION_ID) headers.set('krankque-application-id', KRANKQUE_APPLICATION_ID);
      return headers;
    }
  }),
  tagTypes: ['NOTIFICATIONS'],
  endpoints: (builder) => ({
    getNotifications: builder.query<GetNotificationsResponse, GetNotificationsParams>({
      query: ({ accessToken, limit, skip }) => ({
        url: `/notifications?limit=${limit}&skip=${skip}`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }),
      providesTags: ['NOTIFICATIONS']
    }),

    markAsViewed: builder.mutation<MarkAsViewedResponse, MarkAsViewedRequest>({
      query: ({ accessToken, ids }) => ({
        url: `/notifications/viewed`,
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        body: { ids }
      }),
      invalidatesTags: ['NOTIFICATIONS']
    })
  })
});

export const { useGetNotificationsQuery, useLazyGetNotificationsQuery, useMarkAsViewedMutation } = notificationSlice;
